import React, { useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { DashboardLayout } from "../components/dashboard/DashboardLayout";
import { InvitationsPanel } from "../components/dashboard/InvitationsPanel";
import { MerchantsPanel } from "../components/dashboard/MerchantsPanel";
import { LeadsPanel } from "../components/dashboard/LeadsPanel";
import { StatsPanel } from "../components/dashboard/StatsPanel";
import { AgenciesStatsPanel } from "../components/dashboard/AgenciesStatsPanel";
import { MarketingKitPanel } from "../components/dashboard/MarketingKitPanel";
import { EmailPreviewPanel } from "../components/dashboard/EmailPreviewPanel";
import { UsersPanel } from "../components/dashboard/UsersPanel";
import { DangerZonePanel } from "../components/dashboard/DangerZonePanel";

export default function Admin() {
  const { user, loading, logout } = useAuth();
  const [active, setActive] = useState("leads");

  React.useEffect(() => {
    const handler = () => setActive("invitations");
    window.addEventListener("pde:invite-admin", handler);
    return () => window.removeEventListener("pde:invite-admin", handler);
  }, []);

  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "admin") return <Navigate to="/" replace />;

  const sections = [
    { id: "leads",       label: "Leads",            content: <LeadsPanel /> },
    { id: "merchants",   label: "Commerçants",      content: <MerchantsPanel canAssignLicencie={true} canDelete={true} /> },
    { id: "users",       label: "Équipe",           content: <UsersPanel /> },
    { id: "invitations", label: "Invitations",      content: <InvitationsPanel /> },
    { id: "kit",         label: "Kit marketing",    content: <MarketingKitPanel /> },
    { id: "emails",      label: "Aperçu des emails", content: <EmailPreviewPanel /> },
    { id: "agencies",    label: "Performance agences", content: <AgenciesStatsPanel /> },
    { id: "stats",       label: "Statistiques",     content: <StatsPanel /> },
    { id: "danger",      label: "Zone dangereuse",  content: <DangerZonePanel /> },
  ];

  return (
    <DashboardLayout
      user={user}
      sections={sections}
      active={active}
      onChange={setActive}
      onLogout={logout}
      subtitle="Administrateur Siège"
    />
  );
}
